<ion-content class="relative">
  <form (ngSubmit)="bindConfirm()" class="padding-bottom">
    <ion-list>
      <ion-item *ngIf="isAdmin">
        <app-owner-select></app-owner-select>
      </ion-item>
      <ion-item>
        <app-project-select></app-project-select>
      </ion-item>
      <ion-item>
        <app-zone-select></app-zone-select>
      </ion-item>
      <ion-item>
        <app-level-select [disabled]="!!position"></app-level-select>
      </ion-item>
      <ion-item>
        <app-group-select [disabled]="!!position"></app-group-select>
      </ion-item>
      <ion-item>
        <app-labels-select [disabled]="!!position"></app-labels-select>
      </ion-item>
      <ion-item>
        <app-device-input
          [error]="error"
          (newDevice)="newDevice($event)"
          (calibrationStatus)="calibrationStatus($event)"
          [disabled]="deviceSkipped"
        ></app-device-input>
        <ion-button
          fill="clear"
          slot="end"
          size="default"
          class="skip-device-button"
          (click)="skipSettingDevice()"
          [color]="deviceSkipped ? 'success' : 'primary'"
        >
          <ion-icon slot="icon-only" name="{{deviceSkipped ? 'add-circle-outline' : 'close-outline'}}"></ion-icon>
        </ion-button>
      </ion-item>
      <ion-item *ngIf="position">
        <ion-input
          type="text"
          autocomplete="off"
          [(ngModel)]="customId"
          [ngModelOptions]="{standalone: true}"
          (ionChange)="changeCustomId()"
          label="Custom ID"
          labelPlacement="floating"
          placeholder=""
        ></ion-input>
      </ion-item>
      <ion-item *ngIf="position">
        <ion-input
          type="text"
          autocomplete="off"
          [(ngModel)]="networkId"
          (ionChange)="changeNetworkId()"
          disabled
          label="Network ID"
          labelPlacement="floating"
          placeholder=""
        ></ion-input>
      </ion-item>
    </ion-list>
    <div class="bottom">
      <ion-button
        expand="full"
        [disabled]="isSubmitDisabled()"
        type="submit"
      >bind</ion-button>
    </div>
  </form>
</ion-content>
